import {Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {SettingsAmenity} from '../types/data.types';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {Attachment} from '../types/email-data.types';
import {HistoryItem} from '../views/directory-item/activity/history-item.class';
import {EmailService} from './email.service';
import {AccountPermissionsService} from './account-permissions.service';
import {ConstantsService} from './constants.service';
import {Observable} from 'rxjs/Observable';
import {ApiResponseList} from '../types/api-response/helpers';
import {filter, tap} from 'rxjs/operators';
import {createInitialNetworkEntity, resolveNetworkEntity} from './helper-functions';

declare const toastr: any;
declare const swal: any;
declare const $: any;

@Injectable()
export class SettingsAmenitiesService {
    isSettingsAmenitiesModalShow = false;
    isScheduleModalShow = false;
    isDisabledDatesModalShow = false;
    isLegalAgreementModalShow = false;
    isBookingRequestModalShow = false;
    isDisclaimerModalShow = false;
    showDetailedView = false;
    isPaymentModalShow = false;
    showAddCommentModal = false;
    showAssignToModal = false;
    isViewAttachmentModalShow = false;
    isRemindersModalShow = false;
    firstTimeLoading = true;
    selectedItemData: SettingsAmenity;
    selectedReminderIndex = null;
    statusForChange = '';
    isReadStatusForChange = -1;
    serviceRequestInServiceRequestModal: SettingsAmenity;
    data = {
        allSettingsAmenities: {
            get: '/v1/amenity?expand=buildingAmenity,createdBy,fees,disabledDates,staffNotificationSettings,staffNotificationSettings.userRoles,residentsNotificationSettings,reminders,residentOccupancyTypes,userGroups',
            data: [],
            total: null
        },
    };
    tabId = 'allSettingsAmenities';
    spinnerShow = true;
    showServiceUnavailable = false;
    buildings: Array<any> = [];
    buildingsForRead: Array<any> = [];
    buildingsForUpdate: Array<any> = [];
    buldingsInMultiselectFormat: Array<any> = [];
    selectedItemFormattedBuildingsArray: Array<any> = [];
    activities: HistoryItem[];
    detailsViewSpinnerShow = false;
    modalSpinnerShow = false;
    attachmentsToDisplay: Array<any> = [];
    serviceName: string = 'amenity';
    bookingRequestModalStaffOrResident = '';
    bookingRequestModalNotificationType = '';
    userRoles: Array<any> = [];
    createdStaffMultiselectArray: Array<any> = [];
    approvedStaffMultiselectArray: Array<any> = [];
    declinedStaffMultiselectArray: Array<any> = [];
    requestStaffMultiselectArray: Array<any> = [];
    bookingCreatedStaffCheckbox = false;
    bookingApprovedStaffCheckbox = false;
    bookingDeclinedStaffCheckbox = false;
    bookingRequestStaffCheckbox = false;
    bookingCreatedResidentCheckbox = false;
    bookingApprovedResidentCheckbox = false;
    bookingDeclinedResidentCheckbox = false;
    bookingRequestResidentCheckbox = false;
    occupancyTypesForMultiselect: Array<any> = [];
    groups: Array<any> = [];
    currentAmenityCorporationHasStripeAccount = false;

    constructor(public es: EmailService,
                public api: ApiClientService,
                public urlService: UrlService,
                public emptyRowService: EmptyRowService,
                public account: AccountPermissionsService
    ) {
        this.api.onLogout.subscribe(() => this.buildings = []);
    }

    getData(scrollToTop?) {
        this.getDataByQueryParams(scrollToTop).subscribe();
    }

    getDataByQueryParams(scrollToTop?) {
        this.showServiceUnavailable = false;
        this.firstTimeLoading = false;
        this.data[this.tabId].total = null;

        const tabId = this.urlService.queryParams['tab'];
        const url = this.data[tabId].get;
        const queryParams = this.urlService.getQueryParamsString();

        return this.api.getJson('domainAmenities', `${url}${queryParams}`)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity(
                    (item) => {
                        if (item.building && item.building.bdId) {
                            item.building.id = item.building.bdId;
                        }
                        return SettingsAmenity.fromExistingData(this.account.addPermissionsToEntity(item, this.serviceName));
                    }
                ),
                tap(({loading}) => this.spinnerShow = loading),
                tap(
                    (response) => {
                        this.data[tabId].data = response.entities;
                        this.data[tabId].total = response.total;
                        this.emptyRowService.fillEmptyRow();
                        this.emptyNotificationArrays(); // wtf?
                        if ($('.table')[0] && scrollToTop)
                            $('.table')[0].scrollIntoView();
                    },
                    (error) => {
                        this.showServiceUnavailable = true;
                        this.spinnerShow = false;
                        this.api.errorHandler(error, 'Failed get Amenity Settings');
                    }
                ),
                filter(({finished}) => finished),
                tap(() => {
                    if (this.selectedItemData) {
                        this.selectedItemData = this.data[tabId].data.find(si => si.id == this.selectedItemData.id);
                        if (this.selectedItemData) {
                            this.selectedItemFormattedBuildingsArray = this.buildingAmenityConvertForMultiselect(this.selectedItemData.buildingAmenity);
                            this.selectedItemData.checked = true;
                        } else {
                            this.showDetailedView = false;
                        }
                        this.formatNotificationSettingsRoles();
                    }
                }),
            );
    }

    getBuildings(): void {
        if (this.buildings.length) return;
        const url = `/v1/buildings/short.json?per-page=10000&order-by=name|asc&expand=timeZone,corporationNumber`;
        this.api.get('domainBD', url).subscribe(
            (res) => {
                this.buildings = JSON.parse(res._body).entities;
                this.getFilteredBuildings();
            },
            (error) => this.api.errorHandler(error, 'Failed get buildings')
        );
    }

    resetData() {
        for (const item in this.data) {
            this.data[item].data = [];
            this.data[item].total = null;
        }
    }

    toggleDetailedView(data, state: boolean): void {
        if (data && this.selectedItemData && data.id != this.selectedItemData.id) {
            this.selectedItemFormattedBuildingsArray = this.buildingAmenityConvertForMultiselect(data.buildingAmenity);
        } else if (data && !this.selectedItemData) {
            this.selectedItemFormattedBuildingsArray = this.buildingAmenityConvertForMultiselect(data.buildingAmenity);
        }

        this.selectedItemData = data ? data : null;
        this.showDetailedView = state;

        if (this.selectedItemData) {
            for (const field in this.selectedItemData.formFields) {
                this.selectedItemData.formFields[field].editMode = false;
            }

            this.getStripeAccountInformation(this.selectedItemData.buildingAmenity);
        }
    }

    showAttachment(attachment) {
        const attachmentAsObject = new Attachment(attachment.name, 0, attachment.path);
        if (attachmentAsObject.isImage()) {
            this.es.attachmentInViewAttachmentModal = attachmentAsObject;
            this.es.isViewAttachmentModalShow = true;
        } else if (attachmentAsObject.isNeedViewer()) {
            attachmentAsObject.openViewer();
        } else {
            attachmentAsObject.downloadAttachment();
        }
    }

    canEdit(buildingId?: number) {
        return this.account.canUpdate(this.serviceName, buildingId);
    }

    canDelete(buildingId?: number) {
        return this.account.canDelete(this.serviceName, buildingId);
    }

    getFilteredBuildings() {
        this.buildingsForRead = this.account.getBuildingsForRead(this.buildings, this.serviceName);
        this.buildingsForUpdate = this.account.getBuildingsForUpdate(this.buildings, this.serviceName);
        this.buldingsInMultiselectFormat = this.getBuildingsInProperFormat(this.buildings);
    }

    getBuildingsInProperFormat(arr: Array<any>) {
        return arr.map(
            building => ({
                id: parseInt(building.id),
                itemName: building.name,
                timezone: building.timeZone ? building.timeZone.value : undefined,
                corporationNumberBd: building.corporationNumber ? building.corporationNumber.id : null,
                corporationNumberName: building.corporationNumber ? building.corporationNumber.name : null
            })
        );
    }

    deleteAmenity(amenity) {
        if (!amenity.id) return;
        swal(ConstantsService.getSwalConfig('Delete Amenity'),
            () => {
                const url = `/v1/amenity/${amenity.id}.json`;
                this.api.remove('domainAmenities', url).subscribe(
                    () => {
                        toastr.success('Amenity has been deleted.');
                        if (this.data.allSettingsAmenities.data.length - 1 == 0 && this.urlService.queryParams.page != '1')
                            this.urlService.queryParams.page = (parseInt(this.urlService.queryParams.page) - 1).toString();
                        this.getData();
                    },
                    (error) => this.api.errorHandler(error, 'Delete Amenity failed')
                );
            }
        );
    }

    buildingAmenityConvertForMultiselect(buildings): any { // I am too tired to review this thing, but I suspect O(n + n^2) is not an optimal solution
        let formated = [];
        if (buildings) {
            buildings.forEach(b => formated.push({id: b.buildingId}));
            formated.forEach(b => {
                this.buldingsInMultiselectFormat.forEach(msb => {
                    if (msb.id == b.id) {
                        b.itemName = msb.itemName;
                        b.timezone = msb.timezone;
                        b.corporationNumberBd = msb.corporationNumberBd;
                        b.corporationNumberName = msb.corporationNumberName;
                    }
                });
            });
        }
        return formated;
    }

    public getUserRoles() {
        const url = `/api/v1/role.json`;
        this.api.getInfiniteList('oauthUrl', url, 1000).subscribe(
            res => {
                this.userRoles = res.entities.map(role => ({id: role.id.toString(), itemName: role.name}));
            },
            error => this.api.errorHandler(error, 'Failed get Roles')
        );
    }

    public getGroups() {
        const url = '/v1/group.json';
        this.api.getInfiniteList('domainBD', url, 1000).subscribe(
            res => {
                this.groups = res.entities.map(group => ({
                    id: group.id.toString(),
                    itemName: group.name
                }));
            },
            error => this.api.errorHandler(error, 'Failed to get Groups')
        );
    }

    public formatNotificationSettingsRoles(): any {
        if (this.selectedItemData) {
            this.selectedItemData.staffNotificationSettings.filter((notificationSetting) => {
                this['booking' + (notificationSetting.action.charAt(0).toUpperCase() + notificationSetting.action.slice(1)) + 'StaffCheckbox'] = notificationSetting.enableStatus;
                notificationSetting.userRoles.forEach((role) => {
                    this[notificationSetting.action + 'StaffMultiselectArray'].push({
                        id: role.bdId,
                        itemName: role.roleName
                    });
                });
            });
            this.selectedItemData.residentsNotificationSettings.forEach((resNotification) => {
                this['booking' + (resNotification.action.charAt(0).toUpperCase() + resNotification.action.slice(1)) + 'ResidentCheckbox'] = resNotification.enableStatus;
            });
        }
    }

    emptyNotificationArrays(): void {
        this.createdStaffMultiselectArray = [];
        this.approvedStaffMultiselectArray = [];
        this.declinedStaffMultiselectArray = [];
        this.requestStaffMultiselectArray = [];
        this.bookingCreatedStaffCheckbox = false;
        this.bookingApprovedStaffCheckbox = false;
        this.bookingDeclinedStaffCheckbox = false;
        this.bookingRequestStaffCheckbox = false;
        this.bookingCreatedResidentCheckbox = false;
        this.bookingApprovedResidentCheckbox = false;
        this.bookingDeclinedResidentCheckbox = false;
        this.bookingRequestResidentCheckbox = false;
    }

    getOccupancyTypes() {
        const url = '/v1/all_occupancy_types.json?per-page=10000';
        this.api.get('domainBD', url).subscribe(
            res => {
                this.occupancyTypesForMultiselect = JSON.parse(res._body).entities || [];
                this.occupancyTypesForMultiselect = this.occupancyTypesForMultiselect.map(o => ({
                    id: o.code,
                    itemName: o.name
                }));
            }, error => this.api.errorHandler(error, 'Failed to get occupancy types!')
        );
    }

    getStripeAccountInformation(buildings) {
        const corporations = Array.from(new Set(buildings.map(c => c.corporationNumberBd)));
        const observables = [];
        corporations.forEach(c => {
            const url = `/v1/stripe_account.json?corporation_number_id=${c}`;
            observables.push(this.api.getJson('domainBD', url));
        });

        this.currentAmenityCorporationHasStripeAccount = false;

        Observable.forkJoin(observables).subscribe((responses: Array<ApiResponseList<any>>) => {
            responses.forEach(item => {
                if (item && item.entities && item.entities.length) {
                    this.currentAmenityCorporationHasStripeAccount = true;
                } else if (!(this.selectedItemData && (this.selectedItemData as any).stripeAccount)) {
                    this.selectedItemData.paymentAcceptCreditCards = false;
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/settings-amenities.service.ts